import { CustomFormData, ToothData } from "../../../dentconnect/src/pages/job-request/types";

export enum MessageType {
	JOB_REQUEST_V1 = "job_request_v1",
	JOB_REQUEST_CUSTOM_V1 = "job_request_custom_v1",
	TEXT = "text",
	SHARED_FILE = "shared_file",
	SHARED_FILE_V2 = "shared_file_v2",
	JOB_REQUEST_DENIED = "job_request_denied",
	JOB_REQUEST_ACCEPTED = "job_request_accepted",

	DELIVERY_CREATED = "delivery_created",
	DELIVERY_STATUS_UPDATED = "delivery_status_updated",

	// DEPRECATED
	CONNECTION_REQUEST = "connection_request",
	CONNECTION_REQUEST_ACCEPTED = "connection_request_accepted",
	CONNECTION_REQUEST_DENIED = "connection_request_denied",
}

export type MessageContent =
	| JobRequestMessageV1
	| JobRequestCustomV1
	| TextMessage
	| SharedFileMessage
	| SharedFileMessageV2
	| JobRequestDenied
	| JobRequestAccepted
	| DeliveryCreatedMessage
	| DeliveryStatusUpdatedMessage
	| ConnectionRequest // DEPRECATED
	| ConnectionRequestAccepted // DEPRECATED
	| ConnectionRequestDenied // DEPRECATED

export type JobRequestMessageV1 = {
	type: MessageType.JOB_REQUEST_V1;
	incoming_order_date: string;
	title: string;
	description: string;
	patient_first_name: string;
	patient_last_name: string;
	patient_code: string;
	parent_job_id?: number; // Optional parent job ID for job requests connected to existing jobs
	odontogram_teeth?: ToothData[];
	file_paths?: string[]; //for the case of a job request before a valid connection is established
	file_ids?: string[]; // is optional, since the file_ids are not available in the front end before the job request is sent
};

export type JobRequestCustomV1 = {
	type: MessageType.JOB_REQUEST_CUSTOM_V1;
	incoming_order_date: string;
	customFormData: CustomFormData; // customFormData is a map of the id of the field to the value of the field
	customFormId: string;
	customFormReferences: Record<string, string>; // customFormReferences is a map of the id of the field to the title of the field
	customFormTitle: string; // For historically reasons, we want to keep the title the custom form had at the time of usage
	file_ids?: string[]; // is optional, since the file_ids are not available in the front end before the job request is sent
	parent_job_id?: number; // Optional parent job ID for job requests connected to existing jobs
};

export type TextMessage = {
	type: MessageType.TEXT;
	text: string;
};

/* DEPRECATED */
export type SharedFileMessage = {
	type: MessageType.SHARED_FILE;
	file_id: string;
	text: string;
};

export type SharedFileMessageV2 = {
	type: MessageType.SHARED_FILE_V2;
	file_ids: string[];
	text: string;
};

export type JobRequestDenied = {
	type: MessageType.JOB_REQUEST_DENIED;
};

export type JobRequestAccepted = {
	type: MessageType.JOB_REQUEST_ACCEPTED;
};

/* DEPRECATED */
export type ConnectionRequest = {
	type: MessageType.CONNECTION_REQUEST;
	message: string;
	isRequestByVendor: boolean; // true if a lab adds a dentist or a lab for which it is a vendor
	clientType: "lab" | "med";
};

/* DEPRECATED */
export type ConnectionRequestAccepted = {
	type: MessageType.CONNECTION_REQUEST_ACCEPTED;
};

/* DEPRECATED */
export type ConnectionRequestDenied = {
	type: MessageType.CONNECTION_REQUEST_DENIED;
};

export type DeliveryCreatedMessage = {
	type: MessageType.DELIVERY_CREATED;
	delivery_id: number;
	courier_name: string;
	courier_type: 'person' | 'company';
	description?: string;
};

export type DeliveryStatusUpdatedMessage = {
	type: MessageType.DELIVERY_STATUS_UPDATED;
	delivery_id: number;
	status: string;
	courier_name: string;
	description?: string;
};